<template lang="html">
  <main class="sell container-fluid px-0">
    <StatusBar :breadcrumbs="doneCategory ? [...categoryBreadcrumbs, {name: 'Nueva publicación'}] : [{name: 'Nueva publicación'}]" noLinks noFilters />
    <div v-show="currentScreen === 'form'" class="row">
      <div class="col-12 mx-auto d-none d-sm-block mt-2 mb-0" style="max-width: 1140px;">
        <h3 class="text-primary">Crear publicación</h3>
      </div>
      <div class="sell-form col-12 mt-sm-3 mb-5">
        <ul class="nav nav-tabs d-none d-sm-flex">
          <li class="nav-item">
            <router-link
              :to="pathCategory"
              :class="`nav-link ${step === stepCategory ? 'active' : ''} ${editingPub ? 'disabled' : ''}`">
              Categoría
            </router-link>
          </li>
          <li class="nav-item">
            <div @click="navTabDescription"
                 :class="`nav-link ${step === stepDescription ? 'active' : ''} ${stepsCompleted < 50 ? 'disabled' : ''}`">
              Descripción y Fotos
            </div>
          </li>
          <li class="nav-item">
            <div @click="goToPrice"
                 :class="`nav-link ${step === stepPrice ? 'active' : ''} ${(stepsCompleted < 75 || !formCompleted) ? 'disabled' : ''}`">
              Precio y Cantidad
            </div>
          </li>
          <li class="nav-item" v-if="forSale">
            <div @click="goToDetailPayment"
                 :class="`nav-link ${step === stepPayment ? 'active' : ''} ${(stepsCompleted < 85 || !formCompleted) ? 'disabled' : ''}`">
              Detalle de cobro
            </div>
          </li>
          <li class="nav-item">
            <div @click="goToConfirmation"
                 :class="`nav-link ${step === stepConfirmation ? 'active' : ''} ${(stepsCompleted < 100 || !readyPrice) ? 'disabled' : ''}`">
              Confirmación
            </div>
          </li>
        </ul>
        <div class="sell-form-content p-4">
          <ProgressBar
            class="d-none d-sm-block"
            :title="stepsTitle"
            :progress="stepsCompleted" />
          <div class="tab-content" id="sell-content" style="position: relative; height: 100%">
            <div v-show="step === stepCategory" :class="`tab-pane ${ step === stepCategory ? 'active' : ''}`">
              <PredictCategories v-if="!rootCategory" @selected="handleCategorySelected"/>
              <div class="py-4 px-3 px-sm-0" v-show="rootCategory === 'manual'">
                <RootCategories
                  :deletePending="deletePending"
                  @resetted="deletePending = false"
                  @selected="handleRootCategorySelected"
                  @continue="handleContinuePub"
                  @discard="goToCategory"
                  class="ml-auto ml-sm-0 mr-auto" />
                <a href="#" class="text-center d-block pt-3 d-sm-none">
                  CANCELAR
                </a>
              </div>
              <SubCategories
                v-show="rootCategory && rootCategory !== 'manual'"
                @selected="handleCategorySelected"
                @return="rootCategory = null"
                :root="rootCategory"
                :doneCategory="doneCategory" />
            </div>
            <div v-show="step === stepDescription" :class="`tab-pane ${ step === stepDescription ? 'active' : ''}`">
              <div class="row pt-sm-3">
                <Container key="DescriptionForm" class="col-12 col-sm-9">
                  <div v-if="hasTitle" class="form-group pt-sm-3">
                    <p class="">
                      Título: <strong>{{ $store.state.sell.title }}</strong>
                      <a href="#" class="btn btn-link"> <u>Cambiar</u> <i>(no recomendado)</i></a>
                    </p>
                  </div>
                  <div v-else class="form-group pt-sm-3">

                    <!-- Alert message -->
                    <div class="alert alert-info mb-3 text-center">
                      <div class="font-weight-bold">IMPORTANTE</div>
                      <div>Nunca vamos a contactarte para pedirte códigos ni datos personales.</div>
                    </div>

                    <label class="font-weight-bold">Título</label>
                    <sup class="required-tip">*</sup>
                    <input
                      @focus="isEditing = true"
                      @blur="isEditing = false"
                      placeholder="Ingresá el título de la publicación"
                      class="form-control"
                      type="text"
                      @input="checkTitle"
                      :value="$store.state.sell.title">
                    <small v-if="(checkRequiredFields && !titleOk) || errors.title" class="text-danger">
                      Este campo es obligatorio
                    </small>
                  </div>
                  <div class="form-group">
                    <label class="font-weight-bold">Descripción</label>
                    <sup class="required-tip">*</sup>
                    <textarea
                      @focus="isEditing = true"
                      @blur="isEditing = false"
                      class="form-control"
                      maxlength="5000"
                      @input="checkBody"
                      :value="$store.state.sell.body"
                      placeholder="Ingresá la descripción de la publicación"
                      rows="3"
                      style="max-height: 250px;"></textarea>
                    <small v-if="(checkRequiredFields && !bodyOk) || errors.body" class="text-danger">
                      Este campo es obligatorio
                    </small>
                  </div>
                  <div style="position:relative;">
                    <label class="font-weight-bold pt-2 w-100">
                      Ubicación del producto o servicio
                      <sup class="required-tip">*</sup>
                    </label>
                    <small v-if="(checkRequiredFields && (!readyGeopoint || editGeopoint)) || errors.geopoint" class="text-danger d-block mb-2">
                      Ingresá una ubicación válida
                    </small>
                    <label>
                      Localidad
                      <sup class="required-tip">*</sup>
                    </label>
                    <GmapCheckable
                        v-show="!publicationGeopoint || editGeopoint"
                        @focus="isEditing = true"
                        @blur="handleBlurGeopoint"
                        gMapId="sellGMapAutocomplete"
                        :placesTypes="'(cities)'"
                        :textDisabled="!!publicationGeopoint"
                        noCheckbox
                        @textChanged="addSellGeopoint" />
                    <Loading class="mod-spinner" :active="isFetching" />
                    <div v-if="publicationGeopoint && !editGeopoint" class="sell-geopoint-group">
                      <CheckableText
                        @edit="handleEdit"
                        :value="publicationGeopoint.city"
                        noCheckbox
                        editable
                        textDisabled />
                    </div>
                    <GMapAutocompleteAddress v-if="isInmuebles"
                                             :newCity="newCity"
                                             @focus="isEditing = true"
                                             @blur="isEditing = false"
                                             @addressChanged="handleAddressChanged" />
                  </div>
                  <br>
                  <AttributeInput
                    @focus="isEditing = true"
                    @blur="isEditing = false"
                    v-for="(attr, index) in requiredAttrs"
                    :isEditingPub="editingPub"
                    :attr="attr"
                    :index="index"
                    :key="'reqAttr-' + index" />
<!--                  <Container key="OtherAttrs">-->
<!--                    <AttributeInput-->
<!--                      @focus="isEditing = true"-->
<!--                      @blur="isEditing = false"-->
<!--                      v-for="(attr, index) in otherAttrs"-->
<!--                      v-if="index < displayedOtherAttrs || attr.setted_value"-->
<!--                      :attr="attr"-->
<!--                      :key="'otherAttrs' + index" />-->
<!--                    <button-->
<!--                      v-if="displayedOtherAttrs < otherAttrs.length"-->
<!--                      @click.prevent="displayedOtherAttrs += 2"-->
<!--                      class="btn btn-link text-secondary font-italic pl-0">-->
<!--                      <u>Completar más campos</u>-->
<!--                    </button>-->
<!--                    <br />-->
<!--                  </Container>-->
                  <h6 class="mt-3 mb-0 font-weight-bold">
                    Fotos
                    <sup class="required-tip">*</sup>
                  </h6>
                  <Gallery :isEditing="this.$route.name === 'editPublication'" />
                  <small v-if="(checkRequiredFields && !imagesOk)" class="text-danger">
                    Subí al menos una imagen
                  </small>
                  <br>
                  <h6 class="pt-3 pb-0 font-weight-bold">
                    Datos de contacto
                    <sup class="required-tip">*</sup>
                  </h6>
                  <small v-if="errors.contactData && !atLeastOneContactInfo" class="text-danger">
                    Seleccioná al menos un domicilio, teléfono o email
                    <br>
                  </small>
                  <br>
                  <TabContactInfo
                    @focus="isEditing = true"
                    @blur="isEditing = false"/>
                </Container>
                <div class="d-none d-sm-block col-sm-3">
                  <Widget
                    style="max-width: 13vw;"
                    class="keep-sticky"
                    :completed="visibility" />
                </div>
              </div>
              <div class="mx-auto text-center py-3">
                <SquaredButton
                  @click="goToCategory"
                  styleType="link"
                  label="Anterior"
                  :disabled="editingPub" />
                <SquaredButton
                  v-show="true"
                  @click="goToPrice"
                  styleType="primary"
                  :label="editingPub ? 'Guardar y continuar' : 'Siguiente'" />
              </div>
              <div v-if="checkRequiredFields" class="mx-auto text-center">
                <small class="text-danger">
                  Por favor, revisá los campos marcados como obligatorios
                  <sup class="required-tip">*</sup>
                </small>
              </div>
            </div>
            <div v-show="step === stepPrice" :class="`tab-pane price-tab ${ step === stepPrice ? 'active' : ''}`">
              <TabPrice
                :isReady="readyPrice"
                :errors="errors"
                @focus="isEditing = true"
                @blur="isEditing = false"
                @goToDescription="goToDescription"
                @goToDetailPayment="goToDetailPayment"
                @goToConfirmation="goToConfirmation" />
            </div>
            <div v-show="step === stepPayment" :class="`tab-pane payment-tab ${ step === stepPayment ? 'active' : ''}`">
              <TabDetailPayment
                :detailPayment="detailPayment"
                @calculateDetailPayment="calculateDetailPayment"
                @goToPrice="goToPrice"
                @goToConfirmation="goToConfirmation"
              />
            </div>
            <div v-show="step === stepConfirmation" :class="`tab-pane ${ step === stepConfirmation ? 'active' : ''}`">
              <TabConfirmation
                :readyConfirmation="readyConfirmation"
                @changeScreen="screen => { currentScreen = screen }"
                @goToPrice="goToPrice"
                @goToDetailPayment="goToDetailPayment"
                />
            </div>
            <Loading :active="storeFetching && step !== 'categoria'" top />
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentScreen === 'online'" class="row">
      <ScreenOnline :publicationId="publicationId" />
    </div>
    <div v-show="!editingPub && !isEditing" v-if="stepsCompleted >= 50 && step === 'descripcion'" class="sell-widget row px-2 my-auto d-sm-none">
      <div class="col-5 my-1">
        <Widget :completed="visibility" nolabels />
      </div>
      <div class="col-7 pl-0 my-auto">
        <span class="">Completá más campos y aumentá la visibilidad de tu publicación</span>
      </div>
    </div>
  </main>
</template>

<script>
import store from '@/store'
import StatusBar from '@/components/layout/StatusBarBase'
import PredictCategories from '@/pages/sellPage/PredictCategories'
import RootCategories from '@/pages/sellPage/RootCategories'
import SubCategories from '@/pages/sellPage/SubCategories'
import Gallery from '@/pages/sellPage/gallery/Gallery'
import AttributeInput from '@/pages/sellPage/AttributeInput'
import TabContactInfo from '@/pages/sellPage/tabs/TabContactInfo'
import TabPrice from './tabs/TabPrice'
import TabDetailPayment from './tabs/TabDetailPayment'
import TabConfirmation from './tabs/TabConfirmation'
import ScreenOnline from '@/pages/sellPage/screens/ScreenOnline'
import Widget from '@/components/layout/SellWidget'
import {instance as actionDialog} from '@/components/layout/ActionDialog'
import GmapCheckable from '@/components/ui/forms/GmapCheckable'
import GMapAutocompleteAddress from './GMapAutocompleteAddress'
import { validPriceAmount, trunkFloat } from '@/helpers'
import { fetchCityProvince } from '@/location'
import mixinAutoResize from '@/mixins/autoResize'
import {api, urls} from '@/api'
import $ from 'jquery'

export default {
  mixins: [mixinAutoResize],

  components: {
    StatusBar,
    PredictCategories,
    RootCategories,
    SubCategories,
    Gallery,
    AttributeInput,
    TabContactInfo,
    TabPrice,
    TabDetailPayment,
    TabConfirmation,
    ScreenOnline,
    Widget,
    GmapCheckable,
    GMapAutocompleteAddress
  },

  data: () => ({
    rootCategory: null,
    // control the number of not required attrs showed
    displayedOtherAttrs: 0,
    // for further API feature auto-title
    hasTitle: false,
    // done* control stepsCompleted and disable tabs
    doneRootCategory: false,
    doneCategory: false,
    // screens: 'form', 'highlight', 'online'
    currentScreen: 'form',
    // to hide Widget on mobile
    isEditing: false,
    deletePending: false,
    updateInterval: null,
    hasChanges: false,
    errors: {
      title: false,
      body: false,
      geopoint: false,
      contactData: false
    },
    editingPub: false,
    pathSell: '/publicar/',
    pathEdit: '/editar/',
    stepCategory: 'categoria',
    stepDescription: 'descripcion',
    stepPayment: 'cobro',
    stepPrice: 'precio',
    stepConfirmation: 'confirmacion',
    editGeopoint: false,
    // Last Publication ID set, to be passed as prop to ScreenOnline
    publicationId: null,
    newCity: null,
    addressInput: false,
    detailPayment: {
      details: {
        ml_fee: 0,
        mpv_fee: 0,
        price: 0
      },
      final: {
        amount: 0
      }
    }
  }),

  beforeRouteEnter (to, from, next) {
    // if there is a pending publication
    if (!to.params.step) to.params.step = 'descripcion'
    //Step after the link with mercadopago
    if (to.name === 'authorization') {
      to.params.step = 'precio'
    }
    if (to.name === 'editPublication') {
      next(vm => {
        if (!vm.pubId) {
          vm.editingPub = true
          vm.deletePending = false
          vm.doneRootCategory = true
          vm.doneCategory = true

          store.dispatch('sell/setIsFetching', true)
          store.dispatch('sell/getDraft', to.params.id)
            .then(res => {
              if (to.params.step === 'confirmacion' && vm.pubMlaId) {
                store.dispatch('sell/getCheapestHighlight')
              }
            })
            .finally(() => {
              store.dispatch('sell/setIsFetching', false)
            })
          if (!vm.editableStep)
            vm.goToDescription()
        }
      })
    }
    next()
  },

  beforeRouteUpdate (to, from, next) {
    this.editingPub = to.name === 'editPublication'
    if (to.path === this.pathCategory && this.pubId) {
      this.confirmDiscardDraft(next)
    } else {
      if (to.path === this.pathCategory)
        this.resetForm()
      next()
    }
  },

  beforeRouteLeave (to, from, next) {
    this.editingPub = to.name === 'editPublication'
    if (to.name !== 'editPublication' && to.name !== 'sell') {
      // Going out of editing and draft flows
      // Not calling cleanDraft() because setting deletePending to true triggers a route to root category selection
      this.resetForm()
    } else if (to.name !== from.name && from.name != 'authorization') {
      // Going from editing into draft, or vice versa
      this.cleanDraft()
    }
    if(from.name != 'authorization') {
      store.dispatch('sell/resetInitialState')
    }
    next()
  },

  mounted () {
    // if (!this.isAuth) this.$router.push({ name: 'home' })
    // if not editing publication, direct to first step of publication
    if (this.$route.name !== 'editPublication') {
      this.updateInterval = setInterval(this.compareAndSend, 10000)
    }
    // Insert event listener to prevent changing number inputs whit mouse wheel
    document.addEventListener('wheel', this.blurOnMouseWheel)

  },

  beforeDestroy () {
    clearInterval(this.updateInterval)
    document.removeEventListener('wheel', this.blurOnMouseWheel)
  },

  computed: {
    isAuth: () => store.state.user.isAuth,

    isCommerce: () => store.getters['user/isCommerce'],

    step () { return this.$route.params.step },

    userLocations: () => store.state.user.locations,

    userPhones: () => store.state.user.phones,

    userEmails: () => store.state.user.emails,

    newLocations: () => store.state.temps.newLocations || [],

    pubId: () => store.state.sell.id,

    pubMlaId: () => store.state.sell.mla_category_id,

    publicationGeopoint: () => store.state.sell.geopoint,

    publicationLocations: () => store.state.sell.locations,

    publicationPhones: () => store.state.sell.phones,

    publicationEmails: () => store.state.sell.emails,

    publicationPrice: () => store.state.sell.price.currency_value,

    publicationTitle: () => store.state.sell.title,

    titleOk: () => !!store.state.sell.title,

    publicationBody: () => store.state.sell.body,

    bodyOk: () => !!store.state.sell.body,

    fieldsFilled: () => store.state.sell.fields_filled,

    fieldsFilledOk: () => !!store.state.sell.fields_filled,

    imagesOk: () => store.state.sell.images.length > 0,

    attrWithErrors: () => store.state.sell.attrWithErrors,

    attributes: () => store.state.sell.fetchedAttributes,

    requiredAttrs: () => store.getters['sell/required'],

    otherAttrs: () => store.getters['sell/notRequired'],

    stock: () => store.state.sell.stock,

    forSale: () => parseInt(store.state.sell.forSale),
    stepsCompleted () {
      return this.doneRootCategory
        ? this.doneCategory
          ? this.formCompleted
            ? this.readyPrice
              ? 100 : 75 : 50 : 25 : 0
    },

    stepsTitle () {
      switch (this.$route.params.step) {
        case this.stepCategory:
          return this.stepsCompleted === 0 ? 'Identificá la categoría de la publicación' : 'Elegí las subcategorías'
        case this.stepDescription:
          return 'Ingresá los datos para la publicación'
        case this.stepPrice:
          return 'Seleccioná el precio y la cantidad de la publicación'
        case this.stepConfirmation:
          return 'Confirmá los datos ingresados'
        default:
          return ''
      }
    },

    visibility: () => store.getters['sell/visibility'],

    formCompleted () {
      return !!(this.titleOk &&
        this.bodyOk &&
        this.imagesOk &&
        this.readyGeopoint &&
        this.attrWithErrors.length === 0 &&
        this.atLeastOneContactInfo &&
        !this.editGeopoint &&
        !this.updateError &&
        store.getters['sell/allRequired'] === store.getters['sell/filledRequired'])
    },

    readyGeopoint () {
      const addressRequired = this.isInmuebles
      return !!this.publicationGeopoint && !!this.publicationGeopoint.id && (!addressRequired || addressRequired && this.addressInput)
    },

    validStock () {
      return this.forSale === 0 || this.forSale === 1 && this.stock > 0
    },

    readyPrice () {
      return validPriceAmount(store.state.sell.price.currency_value) && this.validStock
      // return validPriceAmount(store.state.sell.price.currency_value)
    },

    readyConfirmation () {
      return store.state.sell.conditions && this.formCompleted && this.readyPrice
    },

    priceGroup () {
      return `${store.state.sell.price.currency_value} ${store.state.sell.price.currency_code}`
    },

    contactInfoGroup () { return `${this.publicationLocations} ${this.publicationPhones} ${this.publicationEmails}` },

    atLeastOneContactInfo () {
      return (
        this.publicationLocations && this.publicationLocations.length > 0 ||
        this.publicationPhones && this.publicationPhones.length > 0 ||
        this.publicationEmails && this.publicationEmails.length > 0)
    },

    checkRequiredFields: () => store.state.sell.checkRequiredFields,

    pathCategory () { return this.pathSell + this.stepCategory },

    editableStep () { return this.step === this.stepDescription || this.step === this.stepPrice || this.step === this.stepConfirmation },

    categoryBreadcrumbs: () => store.state.sell.category_path,

    parentCategoryId () { return this.categoryBreadcrumbs[0] && this.categoryBreadcrumbs[0].id },

    isInmuebles () { return this.parentCategoryId === 'MPV2' },

    storeFetching: () => store.state.isFetching,

    updateError: () => store.state.sell.apiError,

    isFetching: () => store.state.sell.isFetching,

    shippingType: () => store.state.sell.shipping_type
  },

  watch: {
    attributes () {
      this.hasChanges = true
    },

    publicationTitle () {
      this.hasChanges = this.titleOk ? true : this.hasChanges
    },

    publicationBody () {
      this.hasChanges = this.bodyOk ? true : this.hasChanges
    },

    fieldsFilled () {
      this.hasChanges = this.fieldsFilledOk ? true : this.hasChanges
    },

    publicationGeopoint () {
      this.hasChanges = this.publicationGeopoint ? true : this.hasChanges
    },

    priceGroup () {
      // this.hasChanges = this.readyPrice ? true : this.hasChanges
      this.hasChanges = true;
    },

    contactInfoGroup () {
      this.hasChanges = this.atLeastOneContactInfo ? true : this.hasChanges
    },

    step () {
      if (this.step === 'confirmacion' && this.pubMlaId) {
        if (!this.editingPub) {
          store.dispatch('sell/getRemainingPubs', this.pubMlaId)
        }
        store.dispatch('sell/getCheapestHighlight')
      }
    },

    pubId (newVal, oldVal) {
      if (!!newVal) {
        this.publicationId = newVal
        this.calculateDetailPayment();
      }
    },

    stock () {
      this.hasChanges = true;
    },

    shippingType () {
      this.hasChanges = true;
    },

    forSale () {
      this.hasChanges = true;
    },
  },

  methods: {
    validPriceAmount,
    trunkFloat,
    fetchCityProvince,

    checkTitle (e) {
      this.errors.title = !e.target.value
      store.dispatch('sell/setTitle', e.target.value)
    },

    checkBody (e) {
      this.mixin_autoResize_resize(e)
      this.errors.body = !e.target.value
      store.dispatch('sell/setBody', e.target.value)
    },

    handleRootCategorySelected (id) {
      this.rootCategory = id
      this.doneRootCategory = true
    },

    handleCategorySelected (cat) {
      if (cat === 'manual') {
        this.rootCategory = cat
      } else {
        const p = cat.path_from_root

        store.dispatch('sell/resetInitialState')
          .then(() => store.dispatch('sell/setFetchedAttributes', cat.attributes))
          .then(() => store.dispatch('sell/createDraft', p[p.length - 1].id))
          .then(() => {
            this.pushToDataLayer('Sell page', 'Draft new')
            this.setInitialContactData()
          })
          .catch(this.handleCreateDraftError)
        // If category predicted, root category is not yet selected
        if (!this.doneRootCategory) this.handleRootCategorySelected(p[0].id)
        this.doneCategory = true
        this.goToDescription()
      }
    },

    setInitialContactData () {
      this.userPhones.filter(p => p.public && p.verified).forEach(p => store.dispatch('sell/addPhone', p))
      this.userEmails.filter(e => e.public && e.verified).forEach(e => store.dispatch('sell/addEmail', e))
      // If not in Inmuebles category, take the first public user location as geopoint for the publication
      let promises = []
      this.userLocations.filter(l => l.public).forEach(l => promises = promises.concat(store.dispatch('sell/addLocation', l)))
      Promise.all(promises).then(() => {
        if (!this.isInmuebles) { this.setGeopointFromUserLocations() }
      })
    },

    setGeopointFromUserLocations () {
      let geopoint
      // Loop through the user locations and get the first one with city name that includes Province (with comma)
      this.publicationLocations.forEach(l => {
        const cityString = l.city.split(',')
        if (!geopoint && cityString.length > 1) {
          geopoint = l
          geopoint.lat = l.coordinates.latitude
          geopoint.lon = l.coordinates.longitude
        }
      })
      if (geopoint) store.dispatch('sell/addGeopoint', geopoint)
    },

    handleContinuePub () {
      this.doneRootCategory = true
      this.doneCategory = true
      if (this.publicationGeopoint && this.isInmuebles) {
        document.getElementById('gMapAddress').value = this.publicationGeopoint.string
        this.addressInput = true
      }
      if (this.step === 'categoria' || this.stepsCompleted < 75) {
        this.goToDescription()
      } else if (this.step === 'confirmacion' && this.stepsCompleted < 100) {
        this.goToPrice()
      }
    },

    cleanDraft () {
      this.deletePending = true
      this.resetForm()
    },

    cleanDraftAndContinue (next) {
      this.pushToDataLayer('Sell page', 'Draft discard')
      this.cleanDraft()
      next()
    },

    goToCategory () {
      this.resetForm()
      this.$router.push({ name: 'sell', params: { step: this.stepCategory } })
    },

    navTabDescription () {
      this.compareAndSend()
      this.goToDescription()
    },

    goToDescription () {
      if (this.editingPub)
        this.$router.push({ name: 'editPublication', params: {id: this.pubId || this.$route.params.id, step: this.stepDescription} })
      else
        this.$router.push({ name: 'sell', params: { step: this.stepDescription } })
    },

    goToPrice () {
      if (this.formCompleted) {
        store.dispatch('sell/setFieldsFilled', true)
        this.compareAndSend()
        store.dispatch('sell/setCheckRequiredFields', false)
        this.errors.contactData = false
        if (this.editingPub)
          this.$router.push({ name: 'editPublication', params: {id: this.pubId, step: this.stepPrice} })
        else
          this.$router.push({ name: 'sell', params: { step: this.stepPrice } })
      } else {
        this.errors.contactData = !this.atLeastOneContactInfo
        store.dispatch('sell/setCheckRequiredFields', true)
      }
    },

    async goToDetailPayment () {
      this.compareAndSend()
      if(!this.validStock) return false;
      if (this.editingPub)
        this.$router.push({ name: 'editPublication', params: { id: this.pubId, step: this.stepPayment } })
      else
        this.$router.push({ name: 'sell', params: { step: this.stepPayment } })
    },

    goToConfirmation () {
      this.compareAndSend()
      if (this.editingPub)
        this.$router.push({ name: 'editPublication', params: { id: this.pubId, step: this.stepConfirmation } })
      else
        this.$router.push({ name: 'sell', params: { step: this.stepConfirmation } })
    },


    confirmDiscardDraft (next) {
      const confirm = actionDialog({
        statement: 'Al continuar, se perderán los datos de la publicación',
        positiveLabel: 'Descartar',
        negativeLabel: 'Cancelar',
        positiveAction: () => this.cleanDraftAndContinue(next),
        negativeAction: () => {}
      })
      confirm.$mount(this.$refs.dialogs)
    },

    handleCreateDraftError () {
      const dialog = actionDialog({
        statement: 'Algo Ocurrió',
        positiveLabel: 'Volver',
        negativeLabel: 'Inicio',
        positiveAction: this.goToCategory,
        negativeAction: () => { this.$router.push({ name: 'home' }) }
      })
      dialog.$mount(this.$refs.dialogs)
    },

    compareAndSend () {
      if (this.hasChanges && store.state.sell.title && store.state.sell.body) {
        this.hasChanges = false
        this.compareAddress()
          .then(async () => {
            await store.dispatch('sell/updateDraft')
            this.calculateDetailPayment()
          })
      }
    },

    compareAddress () {
      return new Promise((resolve, reject) => {
        if (this.isInmuebles && this.publicationGeopoint) {
          const currentGeopointAddress = this.publicationGeopoint.string
          const addressFieldValue = document.getElementById('gMapAddress').value
          if (addressFieldValue && currentGeopointAddress !== addressFieldValue) {
            const newGeo = {
              ...this.publicationGeopoint,
              string: addressFieldValue
            }
            const action = this.publicationGeopoint.id ? 'sell/editGeopoint' : 'sell/addGeopoint'
            store.dispatch(action, newGeo)
              .then(() => { resolve() })
          }
        }
        resolve()
      })
    },

    addSellGeopoint (geopoint) {
      // If the object returned from gmap autocomplete is not valid, show error
      if (Object.entries(geopoint).length <= 1) {
        this.errors.geopoint = true
        return
      }
      // Clear error flag
      this.errors.geopoint = false
      store.dispatch('sell/setIsFetching', true)
      // Get lat & lon from gmap autocomplete
      const latLon = {
        lat: trunkFloat(geopoint.geometry.location.lat()),
        lon: trunkFloat(geopoint.geometry.location.lng())
      }
      // Fetch city name from Google Maps API for latLon
      this.fetchCityProvince(latLon)
        .then(location => {
          // Variable to be defined as edit existing or add new geopoint
          let action
          // New geopoint data
          let geo = {
            city: location.city,
            string: geopoint.formatted_address,
            lat: location.lat,
            lon: location.lon
          }
          // If in Inmuebles category
          if (this.isInmuebles) {
            // City to be passed to the address autocomplete element
            this.newCity = location.city
            // If publication already has a geopoint, keep its id to edit it
            if (this.publicationGeopoint && this.publicationGeopoint.id) {
              geo.id = this.publicationGeopoint.id
            }
            // Clear address field to force user input
            document.getElementById('gMapAddress').value = ''
            // Only add the geopoint locally because there's no new address yet
            delete geo.string
            store.dispatch('sell/addLocalGeopoint', geo)
            store.dispatch('sell/setIsFetching', false)
            return
          }
          if (this.publicationGeopoint) {
            action = 'sell/editGeopoint'
            geo.id = this.publicationGeopoint.id
          } else {
            action = 'sell/addGeopoint'
          }
          store.dispatch(action, geo)
            .finally(() => {
              store.dispatch('sell/setIsFetching', false)
              this.editGeopoint = false
            })
        })
    },

    handleBlurGeopoint () {
      this.isEditing = false
      this.editGeopoint = false
    },

    handleAddressChanged (e) {
      if (e) {
        this.hasChanges = true
        this.addressInput = true
      } else {
        this.addressInput = false
      }
    },

    resetForm () {
      this.rootCategory = null
      this.doneRootCategory = false
      this.doneCategory = false
      this.currentScreen = 'form'
      document.getElementById('sellGMapAutocomplete').value = ''
    },

    blurOnMouseWheel () {
      if (document.activeElement.type === 'number')
        document.activeElement.blur()
    },

    handleEdit () {
      this.editGeopoint = true
      // Get the autocomplete input element and focus on it
      const gMapInput = document.getElementById('sellGMapAutocomplete')
      this.$nextTick(() => { gMapInput.focus() })
    },

    calculateDetailPayment () {
      return new Promise((resolve, reject) => {
        api.post(`${urls.publicationSellerAmount}`,{
          "publication_id": this.pubId
        }).then(({ data }) => {
          this.detailPayment = data.data
          resolve(this.detailPayment);
        })
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';
  @import '../../scss/breakpoints';
  @import '../../scss/aspect';

  .sell {
    font-family: 'Roboto', sans-serif !important;
    font-weight: 200 !important;

    padding-top: $navbar-height;
    background-color: $gray-200;

    min-height: 100vh;

    &-geopoint {
      background-color: $gray-200;
      padding: 0.5rem 1rem;

      &-group {
        margin-left: 0;
        margin-right: 0;
      }
    }

    & .nav-tabs {
      & .nav-item {
        & .nav-link {
          color: $gray-800;
          cursor: pointer;

          &.active {
            font-weight: bold;
          }
        }
      }
    }

    &-form {
      max-width: $max-width;
      margin: 3rem auto;

      &-content {
        background-color: $white;
        border-bottom: 1px solid $gray-300;
        border-left: 1px solid $gray-300;
        border-right: 1px solid $gray-300;
      }
    }
  }

  .button-return {
    border: solid 1px $secondary;
    border-radius: 30% 30% 30% 30% / 60% 60% 60% 60%;
  }

  .required-tip {
    color: red;
  }

  .keep-sticky {
    margin: auto;
    position: sticky;
    top: 4rem;
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .sell {
      &-form {
        margin-top: 0;
        margin-bottom: 33%;
        min-height: 82vh;

        &-content {
          height: 100%;
        }

        label {
          color: initial;
        }
      }

      &-widget {
        background-color: $gray-200;
        position: fixed;
        bottom: 0;
        padding-bottom: 0 !important;
      }
    }
  }

  .mp-info {
    height: 0;
    max-height: fit-content;
    overflow: hidden;
    transition: all 0.5s;

    &.expand {
      height: 100%;
    }
  }

  .price-tab {
    min-height: 100% !important;
  }

  .mod-spinner div {
    margin-top: auto !important;
    margin-bottom: auto;
    height: 100% !important;
    background-repeat: no-repeat;
    background-position: center;
  }

  .pac {
    &-item {
      line-height: 35px !important;

      &-query {
        font-size: 1rem !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/SellPage.vue